<template>
	<div class="pxrwwfgv-viewport-container" ref="container">
		<div 
			class="pxrwwfgv-viewport" 
			ref="viewport"
			:style="{'transform': 'scale('+$store.getters['viewportScale']+')'}"
		>
			<div class="pxrwwfgv-viewport-inner">
				<game-screen />
				<fullscreen-alert v-if="showFullscreenAlert"/>
			</div>
		</div>
	</div>
</template>

<script setup >
	import {ref, computed, watch, provide} from 'vue';
	import { useElementSize, useElementBounding, useScreenOrientation } from '@vueuse/core';
	import {useStore} from 'vuex';

	import GameScreen from '@/components/GameScreen.vue';
	import FullscreenAlert from '@/components/FullscreenAlert.vue';

	const store = useStore();

	const container = ref(null);
	const viewport = ref(null);

	provide('viewportContainer', container);

	const viewportBounding = useElementBounding(viewport);

	const containerDimesnions = useElementSize(container);
	const viewportDimesnions = useElementSize(viewport);

	const scale = computed(() => {
		let scaleHorizontal = containerDimesnions.width.value / viewportDimesnions.width.value;
		let scaleVertical = containerDimesnions.height.value / viewportDimesnions.height.value;

		return Math.round(Math.min(scaleHorizontal, scaleVertical) * 1000) / 1000;
	});
	store.dispatch('setViewportScale', scale.value);

	const viewportCoords = computed(() => {
		return [
			(Math.round(viewportBounding.x.value * 1000) / 1000),
			(Math.round(viewportBounding.y.value * 1000) / 1000)
		];
	});
	store.dispatch('setViewportCoords', viewportCoords.value);

	watch(scale, () => {
		store.dispatch('setViewportScale', scale.value);
	});

	watch(viewportCoords, () => {
		store.dispatch('setViewportCoords', viewportCoords.value);
	});

	//screeon orientation
	const {
		isSupported: scoIsSupported,
		orientation: scoOrientation,
	} = useScreenOrientation();

	const showFullscreenAlert = computed(() => {
		return scoIsSupported.value && ['portrait-primary', 'portrait-secondary', 'portrait'].includes(scoOrientation.value)
	});
</script>

<style scoped>
	.pxrwwfgv-viewport-container {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0,0,0,0.2);
	}
	.pxrwwfgv-viewport {
		position: absolute;
		width: 1920px;
		min-width: 1920px;
		max-width: 1920px;
		height: 1080px;
		min-height: 1080px;
		max-height: 1080px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pxrwwfgv-viewport-inner {
		width: 100%;
		height: 100%;
		position: relative;
	}
</style>
